export const LOCALE = 'en-GB';
export const CURRENCY_CODE = 'GBP';
